import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TeamMessageService {

  constructor(private http: HttpClient) { }

  // v1.0/teammessage/current?apexid=zhangw13
  getTeamMessageByApexId(apexId:string): Observable<any> {
    
    let url=`${environment.api.uri}v1.0/teammessage/current?apexid=${apexId}`;
    return this.http.get<any>(url);
  }

  // v1.0/teammessage/read
  markReadTeamMessage(readObject:any): Observable<any> {
    
    let url=`${environment.api.uri}v1.0/teammessage/read`;
    return this.http.post<any>(url, readObject);
  }

  // v1.0/teammessage/1
  getTeamMessageByTeamMessageId(TeamMessageId:string): Observable<any> {
    
    let url=`${environment.api.uri}v1.0/teammessage/${TeamMessageId}`;
    return this.http.get<any>(url);
  }
  
  // v1.0/teammessage/52/attachment
  getTeamMessageAttachmentByTeamMessageId(TeamMessageId:string): Observable<any> {
    let url=`${environment.api.uri}v1.0/teammessage/${TeamMessageId}/attachment`;
    
    return this.http.get(url, { responseType: 'blob' });
  }

}
